import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper'

export const leaveApi = createApi({
  reducerPath: 'leaveApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/leaves` }),
  tagTypes: ['leaves'],
  endpoints: (build) => ({
    fetchAllLeaves: build.query({
      query: (id) => ({
        // url: '/'
        url: `/${id}`,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.leaves.map(({ _id }) => ({ type: 'leaves', id: _id })), // Provide individual tags for each item
              { type: 'leaves', id: 'LIST' } // Special tag for the whole list
            ]
          : [{ type: 'leaves', id: 'LIST' }],
      refetchOnMountOrArgChange: true, // Add this line
    }),
    addLeave: build.mutation({
      query: (newRow) => ({
        url: '/',
        method: 'POST',
        body: newRow
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          leaveApi.util.updateQueryData('fetchAllLeaves', undefined, (draft) => {
            draft.leaves.push(newRow); // Optimistically add the new row to the list
          })
        );

        try {
          await queryFulfilled
          // const { data } = await queryFulfilled;
          // const getLocalStorageProfile = JSON.parse(localStorage.getItem("authUser"))
          // getLocalStorageProfile.result.leave = data.leave;

          // Save the updated object back to localStorage
          // localStorage.setItem("authUser", JSON.stringify(getLocalStorageProfile));

          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic addition on failure
        }
      },
      invalidatesTags: [{ type: 'leaves', id: 'LIST' }]
    }),
    updateLeave: build.mutation({
      query: (updatedRow) => ({
        url: `/${updatedRow.id}`,
        method: 'PUT',
        body: updatedRow
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          leaveApi.util.updateQueryData('fetchAllLeaves', undefined, (draft) => {
            const item = draft.leavesAppr.find((row) => row._id === updatedRow._id);
            if (item) {
              Object.assign(item, updatedRow); // Apply changes optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => [
        { type: 'leaves', id: updatedRow._id },
        { type: 'leaves', id: 'LIST' }
      ]
    }),
    // overall
    updateOverallLv: build.mutation({
      query: (updatedRow) => ({
        url: `overall/${updatedRow.id}`,
        method: 'PUT',
        body: updatedRow
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          leaveApi.util.updateQueryData('fetchAllLeaves', undefined, (draft) => {
            const item = draft.users.find((row) => row._id === updatedRow._id);
            if (item) {
              Object.assign(item, updatedRow); // Apply changes optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => [
        { type: 'leaves', id: updatedRow._id },
        { type: 'leaves', id: 'LIST' }
      ]
    }),
    // holidays
    addHoliday: build.mutation({
      query: (newRow) => ({
        url: '/holiday',
        method: 'POST',
        body: newRow
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          leaveApi.util.updateQueryData('fetchAllLeaves', undefined, (draft) => {
            draft.holidays.push(newRow); // Optimistically add the new row to the list
          })
        );

        try {
          await queryFulfilled
        } catch {
          patchResult.undo(); // Revert optimistic addition on failure
        }
      },
      invalidatesTags: [{ type: 'leaves', id: 'LIST' }]
    }),
    updateHoliday: build.mutation({
      query: (updatedRow) => ({
        url: `holiday/${updatedRow._id}`,
        method: 'PUT',
        body: updatedRow
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          leaveApi.util.updateQueryData('fetchAllLeaves', undefined, (draft) => {
            const item = draft.holidays.find((row) => row._id === updatedRow._id);
            if (item) {
              Object.assign(item, updatedRow); // Apply changes optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => [
        { type: 'leaves', id: updatedRow._id },
        { type: 'leaves', id: 'LIST' }
      ]
    }),
    deleteHoliday: build.mutation({
      query: (id) => ({
        url: `holiday/${id}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          leaveApi.util.updateQueryData('fetchAllLeaves', undefined, (draft) => {
            const index = draft.holidays.findIndex((row) => row._id === id);
            if (index !== -1) {
              draft.holidays.splice(index, 1); // Remove item optimistically
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      },
      invalidatesTags: (result, error, id) => [
        { type: 'leaves', id },
        { type: 'leaves', id: 'LIST' }
      ]
    })
  })
});